import { postApi } from '../api/digitalVault';
/**
 * Move files to a new destination
 * http://mavenrepo.synchronoss.net:8081/nexus/content/sites/sites/com/newbay/vault/5.6.0/htmlsingle/vault-dataapi/index.html#dv.user.repository.operations.copy
 *
 * @param sources files to move
 * @param destinationPath destination path
 * @param destinationRepository destination repository
 * @param optionalParams optional parameters
 * @returns postApi response from operations/copy endpoint
 */
const copy = async (sources, destinationPath, destinationRepository, optionalParams, logger) => {
    const data = new URLSearchParams();
    data.append('destination', destinationPath);
    sources.forEach((s) => data.append('source', s.toString()));
    // add optional params
    Object.entries({
        ...{ preserveCreationDate: true },
        ...(optionalParams || {})
    }).forEach(([key, value]) => {
        data.append(key, `${value}`);
    });
    return await postApi(data, `repository/${destinationRepository}/operations/copy`, {}, logger);
};
export default copy;
